import Entities from './Entities.json';

const decode = (val) => {
  let decoded = "";

  let words = val.split(' ');
  words.map(word => {
    const keys = Object.keys(Entities);
    keys.map(key => {
      const regexp = new RegExp(key, "g");
      word = word.replace(regexp, Entities[key].characters);
    })

    decoded += word + ' '
  })

  return decoded;
}

const He = {decode};

export default He